import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnInit, Sanitizer} from '@angular/core';
import { ActivatedRoute, Router,RouterEvent,NavigationStart,NavigationError,NavigationEnd,NavigationCancel } from '@angular/router';
import { HTTPService } from './services/http.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription, filter } from 'rxjs';
import { UserAuthenticationServices } from './services/user-authentication.services';
import { PrintScreenAlertService } from './system-utils/print-screen-alert/print-screen-alert.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
 
  public loading:Boolean = false;
  sub:Subscription;
  sub2:Subscription;
  sub3:Subscription;
  //private router: Router = Inject(Router);

  constructor( private router: Router, private matIconReg: MatIconRegistry,
    private http:HTTPService,
    private activatedRoute:ActivatedRoute,
    private sanitizer: DomSanitizer,
    public ps:PrintScreenAlertService
   ){

    document.addEventListener('keyup', (e) => {
      if (e.key === 'PrintScreen') {
        navigator.clipboard.writeText('');
        this.ps.showAlert = true;
      }
    });

    this.router.events.pipe(
      filter((e: any | RouterEvent): e is RouterEvent => e instanceof RouterEvent)
    ).subscribe((e: RouterEvent) => {
      this.checkRouterEvent(e);
    });
    
    this.sub2 = this.http.event.subscribe( (event:Event) => {
      this.checkHttpEvent(event)
    },(error)=>{
      setTimeout(() => this.loading = false);
    });      

  }

  async ngOnInit(): Promise<void> {
    this.matIconReg.setDefaultFontSetClass('material-symbols-outlined');

    // Fallback de icones SVG: qualquer nome usado em [svgIcon] que NAO tenha sido
    // registrado explicitamente (addSvgIconLiteral em loadSvgs) resolve, de forma lazy,
    // para o SVG correspondente ja embarcado em assets/outline/<nome>.svg (Material Symbols).
    // Registros explicitos tem precedencia; ligatures (<mat-icon>texto</mat-icon>) nao passam aqui.
    // Corrige os erros "Error retrieving icon :<nome>" (ex.: text_snippet, help_outline) sem
    // remover icones dos seletores e sem alterar os que ja funcionam.
    this.matIconReg.addSvgIconResolver((name: string, namespace: string) => {
      return namespace
        ? null
        : this.sanitizer.bypassSecurityTrustResourceUrl(`assets/outline/${encodeURIComponent(name)}.svg`);
    });
  }

  ngOnDestroy(){
     if ( this.sub != null){ this.sub.unsubscribe(); }
     if ( this.sub2 != null){ this.sub2.unsubscribe(); }
     if ( this.sub3 != null){ this.sub3.unsubscribe();}
  }

  checkHttpEvent(event:Event){
      if ( event.type == "startPost"){
        setTimeout(() => this.loading = true);
      }else{
        setTimeout(() => this.loading = false);
      }
  }

  checkRouterEvent( routerEvent:RouterEvent){
      if (routerEvent instanceof NavigationStart ){
        this.loading  = true;
      }
      
      if ( routerEvent instanceof NavigationError ||
           routerEvent instanceof NavigationEnd ||
           routerEvent instanceof NavigationCancel){
             this.loading = false;
      }

  }

  ngAfterViewInit() {
    //this.cd.detach()
  }
  
}
